export enum ModeloSecadorEnum {
    DRYER = 'dryer',
    HIPERDROP = 'hiperdrop',
    WMS = 'wms'
}
